<template>
  <section>
    <div class="wrapper">
      <div class="cmdp_b">
        <div class="nav">
          <div v-if="!$route.path.includes('/list')" @click="redirectToList">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 icon_mypage">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" />
            </svg>
          </div>
          <div v-else></div>
          <div @click="redirectToList">
            <!-- <img class="img_logo" src="@/assets/img/etners-web/KIOSK.svg"> -->
            업무용 무인 접수 사전예약
          </div>
          <div @click="logout">
            <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 icon_mypage">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ApiConfig from "@/api/api.config";
import ApiUtil from '@/api/api.util'

export default {
  name: "HeaderArea",
  methods: {
    redirectToList () {
      this.$router.push({
        name: 'ReserveList',
      })
    },
    logout () {
      kendo.confirm('로그아웃하시겠습니까?').done(function () {
        sessionStorage.clear()
        setTimeout(function () {
          window.location.href = `${ApiConfig.ssoDomain}/sso/logout.jsp`
        }, 300)
      })
    },
  },
}
</script>

<style scoped>

</style>